<template>
    <div class="pa-5" v-if="activeUser">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "First name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.first_name ? activeUser.first_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Last name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.last_name ? activeUser.last_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Phone" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.phone ? activeUser.phone : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.email ? activeUser.email : "-" }}
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Position" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.position ? activeUser.position : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Role" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.role ? activeUser.role : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeUser.status ? activeUser.status : "-" }}
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-for="item in activeUser.work_roles" :key="item.role">
            <v-col class="col-item row-title" cols="3">{{ formatRoleName(item.role) }}</v-col>
            <v-col class="col-item" cols="6">
                <v-switch class="pt-0 mt-0" v-model="item.value" dense disabled color="primary" />
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <user-permissions v-if="allActions.length > 0 && user.role == 'superadmin'" :disabled="true" :editing="false" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import UserPermissions from "@/components/user-permissions.vue";
export default {
    name: "profile-tab",
    data() {
        return {};
    },
    components: { "user-permissions": UserPermissions },
    computed: {
        ...mapState("UserStore", ["activeUser", "allActions"]),
        ...mapState(["user"])
    },
    methods: {
        formatRoleName(name) {
            name = name.replaceAll("_", " ");

            return this.t(name.charAt(0).toUpperCase() + name.slice(1));
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
::v-deep.v-input--switch {
    height: 12px !important;
}
</style>
